module.exports = __webpack_public_path__ + "img/symbol_marine.2f3464fc.png";